export const locale = {
  lang: 'zh1',
  data: {
    'CIERRE': {
      'LABEL1': '進行中的調研',
      'LABEL2': '查看進度',
      'LABEL3': '已完成的調研',
      'LABEL4': '查看結果',
      'LABEL5': '提醒已發送',
      'LABEL6': '您已經發送了一封電子郵件',
      'LABEL7': '您只能在發布日之後發送提醒',
      'LABEL8': '等一下......',
      'LABEL9': '剩余天數',
      'BTN_CIERRE': '關閉',
      'ALERT':{
        'MESSAGE': '您確認要執行預期的調查嗎？',
        'BTN_CONFIRM': '是',
        'BTN_CANCEL': '沒有',
        'OK':'好',
      },
      'ALERT_RE':{
        'MESSAGE': '¿您確定要發送提醒嗎?',
        'BTN_CONFIRM': '是',
        'BTN_CANCEL': '沒有',
        'OK':'好',
      },
      'LINK': '轉到下一個鏈接以查看調查的當前進度',
      'LINKENCUESTA': '生成鏈接以查看調查的當前進度',
      'ACTIONS':{
        'TITULO': '行動',
        'TITULO_ACTUALIZADO': '提醒事項',
        'TITULO_ACCESS': '進入調查',
        'WANNADO': '你想讓我做什麼？',
        'TITULO_VIRSMS': '虛擬短信門戶',
          'TITULO_MYCODE': 'GetMyCode.culturalgo.com門戶',
          'TITULO_BTNMYCODE': '轉到GetMyCode門戶',
      },
      'COMPLETO':{
        'TAG': '調查成功完成',
        'CARDTIT': '結果查詢',
        'LINK': '轉到下一個鏈接以查看調查中獲得的結果'
      },
      'PULSE':{
        /// Survey advancement
        'LABELPRO': '調查進度',
        'LINKEN': '調查鏈接',
        'LINKRES': '鏈接結果',
        'ENCUESTANOENVIADA': '尚未發布脈搏檢查調查',
      },
      'CIERRE':{
        'BCONTEOS':'計數門戶',
        'BACCESO':'生成訪問密鑰',
        'LINKPORTAL': '將訪問鏈接複製到計數門戶',
        'COPYLINK':'複製到剪貼板',
        'REMANDERC2':'提醒尚未完成調查的人',
        'REMANDER':'提醒事項',
        'REMANDER1':'提醒已開始但仍未完成的人',
        'REMANDER2':'提提醒已開始但仍未完成的人',
        'GETURLSURV_1': '生成調查訪問提供者鏈接',
        'GETURLSURV_2': '生成了調查訪問提供程序的鏈接，現在您可以通過單擊同一按鈕來複製它',
        'GETURLSURV_3': '複製調查訪問提供者鏈接',
        'ASIGUSERDEMO':'分配密碼',
      },
      'MOD_TEX_SEND_RECO':'發送電子郵件...',
    },
  }
};
